import { createStorageAtomFactory } from '@exodus/atoms';
const createFirstMissAtAtom = ({ storage, }) => createStorageAtomFactory({ storage })({
    key: 'first-miss-at',
    defaultValue: {},
});
export default createFirstMissAtAtom;
